import _ from 'lodash';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography,
	useTheme,
} from '@mui/material';
import { useState } from 'react';
import { ApproveDialogButtons } from './FormElementsComponent/FormActionsButtons';

interface Iprops {
	children: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
	title: string;
	handleApprove: any;
	handleReject?: any;
	handleClose: any;
	openDialog: boolean;
	approveDisabled?: boolean;
	approveLabel?: string;
	cancelLabel?: string;
}

export const DialogBox = (props: Iprops) => {
	const theme = useTheme();
	const {
		title,
		handleApprove,
		handleReject,
		openDialog = false,
		handleClose,
		children,
		approveDisabled,
		approveLabel,
		cancelLabel,
	} = props;

	return (
		<Dialog open={openDialog} onClose={handleClose}>
			<DialogTitle id="alert-dialog-title">
				<Typography variant="pageTitle" color={theme.palette.root.formTitle}>
					{title}
				</Typography>
			</DialogTitle>
			<DialogContent>{children}</DialogContent>
			<DialogActions>
				{
					<ApproveDialogButtons
						handleApprove={handleApprove}
						handleReject={handleReject}
						approveLabel={approveLabel}
						approveDisabled={approveDisabled}
						cancelLabel={cancelLabel}
					/>
				}
			</DialogActions>
		</Dialog>
	);
};
